import { DoughnutController, PolarAreaController } from "chart.js";
import { HelixPalette } from "@ideagen/helix-react-core";
// list of your custom colors
const BORDER_COLORS = [
    HelixPalette.teal50, // hx-teal-50 (primary brand)
    HelixPalette.teal90, // hx-teal-90 (brand)
    HelixPalette.pink60, // hx-pink-60 (brand)
    HelixPalette.neutral90, // hx-neutral-90 (brand)
    HelixPalette.blue60, // hx-blue-60 (supporting)
    HelixPalette.red60, // hx-red-60 (supporting)
    HelixPalette.green60, // hx-green-60 (supporting)
    HelixPalette.orange60, // hx-orange-60 (supporting)
];
// Border colors with 75% transparency
const BACKGROUND_COLORS = /* #__PURE__ */ BORDER_COLORS.map((color) => {
    // Convert hex to rgba with 75% opacity
    const hex = color.replace('#', '');
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, 0.75)`;
});
function getBorderColor(i) {
    return BORDER_COLORS[i % BORDER_COLORS.length];
}
function getBackgroundColor(i) {
    return BACKGROUND_COLORS[i % BACKGROUND_COLORS.length];
}
function colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = getBorderColor(i);
    dataset.backgroundColor = getBackgroundColor(i);
    return ++i;
}
function colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(() => getBorderColor(i++));
    return i;
}
function colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(() => getBackgroundColor(i++));
    return i;
}
function getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex) => {
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof DoughnutController) {
            i = colorizeDoughnutDataset(dataset, i);
        }
        else if (controller instanceof PolarAreaController) {
            i = colorizePolarAreaDataset(dataset, i);
        }
        else if (controller) {
            i = colorizeDefaultDataset(dataset, i);
        }
    };
}
export const customChartColors = {
    id: "customChartColors",
    defaults: {
        enabled: true,
    },
    beforeLayout(chart, _args, options) {
        if (!options.enabled) {
            return;
        }
        const { data: { datasets }, } = chart.config;
        const colorizer = getColorizer(chart);
        datasets.forEach(colorizer);
    },
};
